import AvatarEditor from 'react-avatar-editor';
import { ComponentType, forwardRef, useState } from 'react';
import { Slider } from '@mui/material';
import styled from 'styled-components';
import { TNullable } from '@/shared/types';
import { Button } from '@salutejs/sdds-insol';
import { useResize } from '@/shared/lib/hooks/useResize/useResize';
import CloseIcon from '@/shared/assets/icons/close.svg?react';
import cls from './TempImage.module.scss';

const StyledButton = styled(Button)`
    background-color: #333f48;
`;

type Props = {
    tempImage: TNullable<File | string>;
    handleRemovePhoto: () => void;
    handleSave: () => void;
};

interface AvatarEditorProps {
    border: number;
    borderRadius: number;
    className?: string;
    color: number[];
    height: number;
    image: File | string;
    ref?: React.Ref<AvatarEditor>;
    rotate: number;
    scale: number;
    width: number;
}

// Type assertion with custom interface
const TypedAvatarEditor = AvatarEditor as unknown as ComponentType<AvatarEditorProps>;

export const TempImage = forwardRef<AvatarEditor, Props>((props, ref) => {
    const { tempImage, handleRemovePhoto, handleSave } = props;

    const [scale, setScale] = useState(1);
    const [rotation, setRotation] = useState(0);

    const isMobile = useResize() < 768;
    const sliderWidth = isMobile ? '100%' : '250px';

    return (
        <div className={cls.container}>
            <TypedAvatarEditor
                className={cls.photo}
                ref={ref}
                border={0}
                scale={scale}
                rotate={rotation}
                image={tempImage!}
                borderRadius={125}
                color={[255, 255, 255, 0.6]}
                width={isMobile ? 300 : 550}
                height={isMobile ? 300 : 500}
            />

            <button className={cls.close} type="button" onClick={handleRemovePhoto}>
                <CloseIcon fill="#fff" />
            </button>

            <div className={cls.settings}>
                <div className={cls.param}>
                    <span>Увеличение:</span>
                    <Slider
                        min={1}
                        max={3}
                        step={0.1}
                        value={scale}
                        style={{ width: sliderWidth }}
                        onChange={(_e, newValue) => setScale(newValue)}
                    />
                </div>
                <div className={cls.param}>
                    <span>Поворот:</span>
                    <Slider
                        min={0}
                        step={1}
                        max={360}
                        value={rotation}
                        style={{ width: sliderWidth }}
                        onChange={(_e, newValue) => setRotation(newValue)}
                    />
                </div>
            </div>

            <StyledButton view="dark" type="button" stretch onClick={handleSave}>
                <span className="SBSansText">Сохранить изменения</span>
            </StyledButton>
        </div>
    );
});

TempImage.displayName = 'TempImage';
